<h1 mat-dialog-title>Update Password</h1>

<form [formGroup]="updatePasswordForm"
  (ngSubmit)="updatePasswordForm.valid && dialogRef.close(updatePasswordForm.value.password)" novalidate
  autocomplete="off" autocorrect="off">
  <div mat-dialog-content fxLayout="column" fxAlign="center center">
    <div class="height-auto">
      <div fxLayout="column" fxLayoutGap="20px">
        <mat-form-field>
          <input escCustomId="new_password" escComponentName="esc_login" matInput required placeholder="New Password"
            minlength="8" maxlength="60" [formControl]="updatePasswordForm.controls['password']"
            [type]="show.password ? 'text' : 'password'">

          <mat-icon escCustomId="new_password" *ngIf="updatePasswordForm.controls['password'].value"
            [svgIcon]="show.password ? 'eye-off' : 'eye'" (click)="show.password = !show.password" matSuffix>
          </mat-icon>

          <mat-error escCustomId="new_password_required"
            *ngIf="updatePasswordForm.controls['password'].hasError('required')">
            New Password is required
          </mat-error>
          <mat-error escCustomId="new_password_min_len"
            *ngIf="updatePasswordForm.controls['password'].hasError('minlength')">
            New Password should be at least 10 characters long
          </mat-error>
          <mat-error escCustomId="new_password_max_len"
            *ngIf="updatePasswordForm.controls['password'].hasError('maxlength')">
            New Password should be at most 60 characters long
          </mat-error>
          <mat-error escCustomId="new_password_pattern"
            *ngIf="updatePasswordForm.controls['password'].hasError('pattern')">
            New Password must contain at least 1 lowercase, uppercase, number and a symbol
          </mat-error>
          <mat-error escCustomId="new_password_invalid"
            *ngIf="updatePasswordForm.controls['password'].hasError('invalidPassword')">
            Invalid Password
          </mat-error>
        </mat-form-field>

        <mat-form-field>
          <input escCustomId="confirm_password" matInput required placeholder="Confirm Password"
            [formControl]="updatePasswordForm.controls['confirmPassword']" [type]="show.confirm ? 'text' : 'password'">

          <mat-icon escCustomId="confirm_password" *ngIf="updatePasswordForm.controls['confirmPassword'].value"
            [svgIcon]="show.confirm ? 'eye-off' : 'eye'" (click)="show.confirm = !show.confirm" matSuffix>
          </mat-icon>
          <mat-error escCustomId="confirm_password_required"
            *ngIf="updatePasswordForm.controls['confirmPassword'].hasError('required')">
            Confirm Password is required
          </mat-error>
          <mat-error escCustomId="confirm_password_incorrect"
            *ngIf="updatePasswordForm.controls['confirmPassword'].hasError('matchPassword')">
            Confirm Password is incorrect
          </mat-error>
        </mat-form-field>

        <button scCustomId="update" color="primary" mat-raised-button type="submit">Update</button>
      </div>
    </div>
  </div>
</form>